export function getFirstYearInCalendar(itemsNumber) {
    return Math.floor(new Date().getFullYear() / itemsNumber) * itemsNumber + 1;
}
export function getPageIndexForSelectedYear(year, firstYearInCalendar, itemsNumber) {
    const lastYearInTable = firstYearInCalendar + (itemsNumber - 1);
    if (year > lastYearInTable) {
        return Math.ceil((year - lastYearInTable) / itemsNumber);
    }
    else if (year < firstYearInCalendar) {
        return Math.floor((year - firstYearInCalendar) / itemsNumber);
    }
    return 0;
}
export function formatYear(year) {
    if (year === undefined || year === null) {
        return '';
    }
    return year.toString().padStart(4, '0');
}
